/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".devices[_ngcontent-%COMP%]{position:relative;left:6.5vw;display:block;width:auto;height:100%;margin:0 auto}"];
export { styles as styles };
